<template>
  <div>
    <wallet-call-back-desktop v-if="screenType === 'desktop'"></wallet-call-back-desktop>
    <wallet-call-back-mobile v-else></wallet-call-back-mobile>
  </div>
</template>

<script>
import WalletCallBackDesktop from "@/components/Pages/Desktop/Dashboard/WalletCallBackDesktop.vue";
import WalletCallBackMobile from "@/components/Pages/Mobile/Dashboard/WalletCallBackMobile.vue";

export default {
  name: "DashboardIndexMain",
  components: {WalletCallBackMobile, WalletCallBackDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>